import React, { FC, useMemo } from "react"
import { AppDetailBase } from "../../../../AppDetailBase/AppDetailBase"
import { turbine } from "neql"
import { useNeqlContextProvider } from "../../../../../../../../../Hooks/useNeqlContextProvider"
import { TutorialContent } from "./TutorialContent"
import { Redirect, RouteComponentProps } from "react-router"
import { routePaths } from "../../../../../../../../../Routes"
import { decodeJobContentPoolParams } from "./JobContentPool"

interface QualifierTutorialContentProps {
    orgUsername: string
    appID: string
    qualifierID: string
}

export const QualifierTutorialContent: FC<
    RouteComponentProps<QualifierTutorialContentProps>
> = ({
    match: {
        params: { appID, qualifierID, orgUsername }
    },
    location
}) => {
    const clientContext = useNeqlContextProvider("turbine")

    const qualifier = turbine.useFetchTrainingTutorialQuery({
        variables: {
            trainingTutorialId: qualifierID
        },
        client: clientContext
    }).data?.trainingTutorial

    const { title, body, breadcrumbs } = useMemo(() => {
        const decodeJobsParams = decodeJobContentPoolParams(
            new URLSearchParams(location.search)
        )
        if (!decodeJobsParams.isError) {
            return {
                title: `${qualifier?.taskInfo?.title ?? ""} content`,
                breadcrumbs: [
                    "Workers",
                    "Worker qualification",
                    "Tutorial content"
                ],
                body: qualifier ? (
                    <TutorialContent
                        orgUsername={orgUsername}
                        appID={appID}
                        qualifierID={qualifierID}
                        trainingId={qualifier.trainingId}
                        {...decodeJobsParams.value}
                    />
                ) : null
            }
        }
        return {
            title: "Content pool",
            breadcrumbs: ["Workers", "Worker qualification", "Content"],
            body: (
                <Redirect
                    to={routePaths.appQualifierTutorialContent(
                        orgUsername,
                        appID,
                        qualifierID
                    )}
                />
            )
        }
    }, [appID, location.search, orgUsername, qualifier, qualifierID])

    const baseProps = useMemo(
        () => ({
            id: appID,
            title,
            breadcrumbs,
            fixedContentWidth: false,
            orgUsername
        }),
        [appID, breadcrumbs, orgUsername, title]
    )

    return <AppDetailBase {...baseProps}>{body}</AppDetailBase>
}
